import { render, staticRenderFns } from "./adminid.vue?vue&type=template&id=50c7c534&"
import script from "./adminid.vue?vue&type=script&lang=js&"
export * from "./adminid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports